import useAxios from 'hooks/useAxios';

const buildEmptyPaginatedResponse = () => ({
  data: [],
  meta: {
    totalItems: 0,
    itemCount: 0,
    itemsPerPage: 0,
    totalPages: 0,
    currentPage: 0
  }
});

const getUserFromSkinsResponse = async (api, id) => {
  const response = await api.get(`/skins/skins-for-user/${id}`);
  return response?.data?.user || null;
};

export const getPlayers = async (limit = 20, page = 1, filters = '') => {
  const api = useAxios();
  try {
    const params = {
      limit: limit,
      page: page,
      sortBy: 'createdAt:DESC'
    };

    if (Object.keys(filters).length) {
      if (filters.users.length) {
        params['id'] = `${filters.users.map((u) => u.id).toString()}`;
      }
      if (filters?.isDemo) {
        params['filter.isDemo'] = `${filters.isDemo}`;
      }
      if (filters?.search) {
        params['search'] = `${filters?.search}`;
      }
    }

    const unformattedData = await api.get('/users/players', {
      params: params
    });
    return {
      data: unformattedData.data?.data,
      meta: unformattedData.data.meta
    };
  } catch (err) {
    console.error(err);
    return buildEmptyPaginatedResponse();
  }
};

export const getPlayer = async (id, params) => {
  const api = useAxios();
  try {
    return await getUserFromSkinsResponse(api, id);
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const getPlayerWithoutParams = async (id) => {
  const api = useAxios();
  try {
    return await getUserFromSkinsResponse(api, id);
  } catch (err) {
    console.error(err);
    return null;
  }
};

export const deletePlayer = async (id) => {
  const api = useAxios();
  return await api.delete(`/users/${id}`);
};

export const updatePlayerName = async (id, name) => {
  const api = useAxios();
  try {
    const response = await api.patch(`/users/${id}/nickname`, {
      nickname: name
    });
    if (response.status === 200) {
      alert(`Player has new name now: ${name}`);
    } else {
      console.error(`Error updating user: Unexpected status code ${response.status}`);
      alert(`Error updating user: Unexpected status code ${response.status}`);
    }
  } catch (err) {
    console.error(`Error updating user:`, err);
    alert(`Error updating user: ${err.message}`);
  }
};

export const getGameMetricsByPlayer = async (userId, startDate, endDate, gameType, metricType) => {
  const api = useAxios();
  let params = {
    startDate,
    endDate,
    metricType,
    userId
  };

  if (gameType) {
    params.gameType = gameType;
  }
  try {
    const response = await api.get(`/admin/metrics/metric-amounts-by-user`, { params: params });

    return response.data;
  } catch (err) {
    console.error(`Error updating user:`, err);
  }
};

export const addResources = async (userId, gemsAmount, coinsAmount, grantVip = false) => {
  const api = useAxios();
  const hasGems = gemsAmount !== '' && gemsAmount !== null && gemsAmount !== undefined;
  const hasCoins = coinsAmount !== '' && coinsAmount !== null && coinsAmount !== undefined;
  const hasVipUpdate = grantVip === true;

  if (!hasGems && !hasCoins && !hasVipUpdate) {
    throw new Error('Please provide gems, coins, or VIP status.');
  }

  try {
    const responses = [];

    if (hasGems || hasCoins) {
      const params = { userId };

      if (hasGems) {
        params.gemsAmount = Number(gemsAmount);
      }

      if (hasCoins) {
        params.coinsAmount = Number(coinsAmount);
      }

      responses.push(await api.post(`/finance/add-funds`, params));
    }

    if (hasVipUpdate) {
      responses.push(
        await api.patch(`/users/${userId}/vip-tier`, {
          vip: 1,
          manualVip: true
        })
      );
    }

    return responses[responses.length - 1];
  } catch (err) {
    console.error(`Error updating user:`, err);
    throw err;
  }
};

export const addResourcesGlobal = async (gemsAmount, coinsAmount) => {
  let params = {};
  if (gemsAmount) {
    params.gemsAmount = gemsAmount;
  }
  if (coinsAmount) {
    params.coinsAmount = coinsAmount;
  }
  const api = useAxios();

  try {
    const response = await api.post(`/finance/global-add-funds`, params);

    return response;
  } catch (err) {
    return err;
  }
};
